import React from 'react';
import { IoSettingsOutline } from 'react-icons/io5';
interface FixedSearchBoxProps{
    onClick?: ()=>void;
}
const FixedSearchBox: React.FC<FixedSearchBoxProps> = ({onClick}) => {
    return (
        <button onClick={onClick} className='fixed top-1/2 right-0 transform -translate-y-1/2 transition-colors duration-300 bg-green-600 hover:bg-sky-600 px-2 z-50 py-1 rounded-l-full shadow-2xl hidden lg:block'>
            <div className="cursor-pointer rounded-sm text-gray-100 flex items-center justify-center">
                <p className="text-center text-sm select-none hover:animate-spin">
                    <IoSettingsOutline size={20} className='text-white' />
                </p>
            </div>
        </button>
    );
};

export default FixedSearchBox;